import { render, staticRenderFns } from "./ModalCancelTransactionDetail.vue?vue&type=template&id=55a2f871&"
import script from "./ModalCancelTransactionDetail.vue?vue&type=script&lang=js&"
export * from "./ModalCancelTransactionDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports